import {
    colorBaseWhite,
    layoutGutterMedium,
    ProductButton,
    ProductHeading,
    ProductParagraph,
} from '@issuu/silkscreen';
import React, { useCallback, useContext } from 'react';
import styled from 'styled-components';

import DocumentContext from '../DocumentPage/DocumentContext';

const Root = styled.main`
    width: 100%;
    height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: ${colorBaseWhite};
`;

const ButtonLine = styled.div`
    width: 15em;
    display: flex;
    justify-content: space-around;
    margin-top: ${layoutGutterMedium};
    button {
        text-transform: uppercase;
    }
`;

const Heading = styled(ProductHeading).attrs({ level: 2 })`
    text-transform: capitalize;
    margin-bottom: ${layoutGutterMedium};
`;

const LoggedinMessage = styled.div`
    margin-top: ${layoutGutterMedium};
`;

const Content = styled.div`
    width: 28em;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    text-align: center;
`;

type Props = {
    onClose: () => void;
};
export const ContentWarning: React.FC<Props> = ({ onClose }) => {
    const {
        document: {
            documentName,
            username,
            contentRating: { isReviewed },
        },
        visitor: { isLoggedIn },
        hosts: { main },
    } = useContext(DocumentContext);

    const onLogin = encodeURIComponent(`https://${main}/${username}/docs/${documentName}`);
    const getOnLogin = (path: 'signin' | 'signup') =>
        `https://${main}/${path}?onLogin=${onLogin}&issuu_product=document_page&issuu_context=action&issuu_cta=explicit_warning`;

    const open = useCallback((url: string) => () => (window.location.href = url), []);

    const UnderReview = (
        <Content>
            <Heading>under review</Heading>
            <ProductParagraph>
                This publication is still pending review and will be available shortly.
            </ProductParagraph>
            <ButtonLine>
                <ProductButton onClick={() => history.back()} role="link" variant="tertiary">
                    go back
                </ProductButton>
                <ProductButton onClick={open(`https://${main}`)} role="link" variant="secondary">
                    go home
                </ProductButton>
            </ButtonLine>
        </Content>
    );

    const ExplicitWarning = (
        <Content>
            <Heading>content warning</Heading>
            <ProductParagraph>
                {`This publication may contain content that is inappropriate for some users, as flagged by issuu's user community.`}
            </ProductParagraph>
            {!isLoggedIn ? (
                <LoggedinMessage>
                    <ProductParagraph>
                        To view this publication, please verify that you are 18 or older by signing
                        in or signing up.
                    </ProductParagraph>
                </LoggedinMessage>
            ) : null}
            <ButtonLine>
                {isLoggedIn ? (
                    <ProductButton onClick={onClose} variant="primary">
                        I understand
                    </ProductButton>
                ) : (
                    <>
                        <ProductButton
                            onClick={open(getOnLogin('signin'))}
                            role="link"
                            variant="tertiary"
                        >
                            sign in
                        </ProductButton>
                        <ProductButton
                            onClick={open(getOnLogin('signup'))}
                            role="link"
                            variant="secondary"
                        >
                            sign up
                        </ProductButton>
                    </>
                )}
            </ButtonLine>
        </Content>
    );
    return <Root>{isReviewed ? ExplicitWarning : UnderReview}</Root>;
};
